<script>
  import { onMount } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher();
  const defaultFeed = {uri: "", name: "", format: "", xpath: "", tag_ids: []}
  
  export let form_id = window.TOPIC_FEED_FORM_ID;
  export let topic_slug = null;
  
  let feed = Object.assign({}, defaultFeed);
  let feed_preview = null;
  
  function commit() {
    if (feed.uri == "" || !feed.id)
      return;
  
    // Link feed and topic
    request.put(`/form/${form_id}`)
    .send({feed_ids: feed.id, id: topic_slug})
    .then(resp => {
      feed_preview = null;
      feed = Object.assign({}, defaultFeed);
    });
  
    // Set freshness minutes
    request.put(`/form/805695fb-469d-4a6e-b235-68b0859775fd`)
    .send({freshness_minutes: 600, id: feed.id})
    .then(resp => {
      feed_preview = null;
      feed = Object.assign({}, defaultFeed);
    });
  
  }
  
  function preview() {
    feed_preview = null;
    if (feed.uri == "")
      return;
    request.post(`/forg/1b1acab4-4da9-4c9c-bdfd-e3c4460a384d`)
    .send({uri: feed.uri, tag_ids: []})
    .then(resp => {
      feed.id = resp.body.feed_id;
      feed_preview = {
        id: resp.body.feed_id,
        name: resp.body.feed_name,
        entries: resp.body.feed_entries
      };
    });
  }
  
  function cancel() {
    dispatch('cancel');
  }
  
  onMount(() => {
    feed = Object.assign({}, defaultFeed, feed);
  });
</script>
<div class='card border-danger feed-preview'>
<form action='/form/{form_id}' class='card-body form-inline'>
<fieldset class='col-12 input-group'>
<label class='form-label text-muted sr-only' for='feed-uri'>Odkaz</label>
<input bind:value='{feed.uri}' class='form-control mr-2 underline-input' id='feed-uri' on:blur='{preview}' placeholder='URI feedu pro tuto stránku' type='text'>
{#if feed_preview}
<button class='btn btn-primary' on:click|preventDefault='{commit}' rel='button'>
<i class='fa fa-save'></i>
</button>
{:else}
<button class='btn btn-secondary' on:click|preventDefault='{preview}' rel='button'>
<i class='fa fa-search'></i>
</button>
{/if}
</fieldset>
</form>
{#if feed_preview}
<div class='card-body text-smlr pt-0'>
<div class='mx-auto'>
<div class='badge badge-secondary'>
Náhled
</div>
</div>
{#each feed_preview.entries.slice(0, 4) as {title, link, about, time}, i}
<div class='mb-1'>
<h5 class='card-title'>
<a href='{link}'>
{title}
</a>
</h5>
<small class='card-subtitle'>{time}</small>
<span class='card-text elipsis2 text-muted' title='{about}'>{about}</span>
</div>
{/each}
</div>
{/if}
</div>
